module.exports={
    "_configuration_": "production",
    "apiUrlBase": "https://rts.hb101.org/v1/",
    "assetBase": "//production.rts-client.hb101.org/1f59dd450ff7f73dbc89ef551959d4da39a4e0e0/assets/",
    "disabledViews": {
        "console": true
    },
    "gaClientId": "UA-6354151-13",
    "measurementId": "G-8C9CXJB2M1",
    "geolocation": "hinckley",
    "geolocations": {
        "duluth": {
            "latitude": 46.8008,
            "longitude": -92.0956
        },
        "hinckley": {
            "latitude": 46.015,
            "longitude":-92.9388889
        },
        "minneapolis": {
            "latitude": 44.9778,
            "longitude": -93.2650
        }
    },
    "googleApiKey": "AIzaSyBmH6gD6WTrw-fr-p85OqzG0tMQg5IqsEg",
    "mapBase": "https://d141574myb3p2y.cloudfront.net/",
    "useGeolocation": true
}
